import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_JOB_ID, waitForJobWithEntityResult } from 'src/graphql/job';
import { stringifyIfPresent } from 'src/lib/common';
import { getGqlFragmentName, getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_LONG_FORM_SUGGEST_CONTENT } from './schema';

export const suggestLongFormBuilderSection = async (
  {
    projectId,
    sectionId,
    assetType,
    recomposeMode,
    continueMode,
    generationLength,
    instruction,
    tovInput,
    markedSegment,
    debugAcPrompt,
    freestyleToolAllInstructionsData,
    url,
    urlExtractions,
    isParagraphMode,
    onlyImproveScore,
    structureInstructionsData,
  },
  options = null
) => {
  const resultFragment = FRAGMENT_LONG_FORM_SUGGEST_CONTENT;
  const fragment = options?.async ? FRAGMENT_JOB_ID : resultFragment;
  const mutation = gql`
    mutation SuggestLongFormBuilderSection(
      $async: Boolean
      $projectId: ID!
      $sectionId: ID!
      $assetType: AssetTypeEnum!
      $recomposeMode: RecomposeModeEnum
      $continueMode: ContinueModeEnum
      $generationLength: String!
      $instruction: Instruction
      $tovInput: TovInput
      $markedSegment: MarkedSegment
      $debugAcPrompt: String
      $freestyleToolAllInstructionsData: JSON
      $url: String
      $urlExtractions: [UrlExtractionInput!]
      $isParagraphMode: Boolean
      $onlyImproveScore: Boolean
      $structureInstructionsData: JSON
    ) {
      suggestLongFormBuilderSection(
        async: $async
        projectId: $projectId
        sectionId: $sectionId
        assetType: $assetType
        recomposeMode: $recomposeMode
        continueMode: $continueMode
        generationLength: $generationLength
        instruction: $instruction
        tovInput: $tovInput
        markedSegment: $markedSegment
        debugAcPrompt: $debugAcPrompt
        freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
        url: $url
        urlExtractions: $urlExtractions
        isParagraphMode: $isParagraphMode
        onlyImproveScore: $onlyImproveScore
        structureInstructionsData: $structureInstructionsData
      ) {
        ...${getGqlFragmentName(fragment)}
      }
    }
    ${fragment}
  `;

  const variables = {
    async: options?.async ?? false,
    projectId,
    sectionId,
    assetType,
    recomposeMode,
    continueMode,
    generationLength,
    instruction,
    tovInput,
    markedSegment,
    debugAcPrompt,
    freestyleToolAllInstructionsData: stringifyIfPresent(freestyleToolAllInstructionsData),
    url,
    urlExtractions,
    isParagraphMode,
    onlyImproveScore,
    structureInstructionsData: stringifyIfPresent(structureInstructionsData),
  };

  const response = await executeGqlMutation({
    mutation,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });

  const result = getSingleProp(response.data);
  if (!options?.async) {
    return result;
  }

  return waitForJobWithEntityResult(result.id, resultFragment, {
    abortSignal: options?.abortSignal,
  });
};
